export default {
    INFO: 0,
    CONFIRMATION: 1
};
